<template>
    <AdminPanelYoutvPackageSellingHistory />
   </template>
   
   <script>
   import AdminPanelYoutvPackageSellingHistory from '../components/AdminPanelYoutvPackageSellingHistory.vue'
   export default {
       data: () => ({}),
       components: {
           AdminPanelYoutvPackageSellingHistory
       },
       methods: {},
       mounted() {}
   }
   </script>
   